import {
  addMiliseconds,
  convertToDayJsObj,
  getDateToSave,
  getDayjs,
  US_LONG_AM_PM_UI
} from 'solaris-lens-common-lib/src/utils/dates';

export const getIntervalOptions = intervals => {
  if (!intervals) return [];
  return intervals?.map(int => ({
    label: int.label,
    value: int.interval,
    maxRangeMillis: int.maxRangeMillis
  }));
};

const categoryOptions = [
  { value: 'measures', label: 'Measures' },
  { value: 'shutdowns', label: 'Shutdowns' },
  { value: 'alarms', label: 'Alarms' }
];

export const getMaxRangeMillis = (intervals, interval) => {
  return intervals?.find(int => int.interval === interval)?.maxRangeMillis;
};

export const getCategoryOptions = () => {
  return categoryOptions;
};

export const getScopeOptions = scopes => {
  if (!scopes) return [];
  return Object.entries(scopes).map(([key, value]) => {
    return {
      label: capitalize(value.label),
      value: key
    };
  });
};

export const getMetricOptions = metrics => {
  if (!metrics) return [];
  return metrics.map(({ key, label }) => ({
    label: capitalize(label),
    value: key
  }));
};

export const getEndDate = (startDate, interval) => {
  const endDate = addMiliseconds(getDateToSave(startDate), interval);
  const now = getDayjs();

  return now.isAfter(convertToDayJsObj(endDate))
    ? endDate
    : now.format(US_LONG_AM_PM_UI);
};

export const getStartDate = (endDate, interval) => {
  return addMiliseconds(getDateToSave(endDate), -interval);
};

function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
